import React, { useState, useEffect, useContext} from "react"

import { usePDF, Resolution } from 'react-to-pdf';

import {
  Box,
  Container,
  Button,
  Hidden,
} from '@material-ui/core';
import moment from 'moment';
import 'moment/locale/fr'

import MyModal from "../ui/MyModal"
import NewCertifChart from "./NewCertifChart"
import Rapport from "./Rapport"
import CloseIcon from '@material-ui/icons/Close';

const ViewResultsModal = ({ isOpen, user, actScan, onClose, type}) => {

  const capitalizeFirstLetter = (val) => {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
  }

  const getDatasForChart = (withoutTooltips) => {
    let labels = []
    let datasets = []
    let labelsDotColors = []
    let labelsIcons = []
    let labelsCategories = ['communication','efficacite','leadership']
    let softSkillsByFamily = actScan?.finalSoftSkills?.sort((a, b) => a?.family?.localeCompare(b?.family)); //on trie par famille (par nom de famille croissant)
    softSkillsByFamily?.forEach((skill) => {
      labels.push(capitalizeFirstLetter(skill?.key))
      if (skill?.family === labelsCategories[0]) {
        labelsDotColors.push("rgba(255, 81, 6, 1)")
      } else if (skill?.family === labelsCategories[1]) {
        labelsDotColors.push("rgba(79, 57, 255, 1)")
      } else if (skill?.family === labelsCategories[2]) {
        labelsDotColors.push("rgba(243, 144, 255, 1)")
      }

    })

    let findResult
    let resultFin = null
    if (type === "recruiter") {
      findResult = actScan?.userResults?.find((el) => el.userID === user?.userID)
      try {
        resultFin = JSON.parse(findResult?.resultFin)
      } catch(e) {
        console.log(e)
        return null
      }
    } else if (type === "candidat") {
      try {
        resultFin = JSON.parse(user?.resultFin)
      } catch(e) {
        console.log(e)
        return null
      }
    }


    softSkillsByFamily?.forEach((skill) => {
      if (resultFin[skill.key]) {
        skill.score = resultFin[skill.key]?.score
      } else {
        skill.score = 0
      }

      //pour afficher les icones à coté des labels
      if (skill?.score < skill?.seuil) {
        labelsIcons.push("error")
      } else {
        labelsIcons.push(skill.family)
      }
    })

    let dashStyle = undefined
    labelsCategories?.forEach((cat, index) => {
      let arr = []
      let labelsNbr = 0
      softSkillsByFamily?.forEach((skill) => {
        if (skill.family === cat) {
          labelsNbr++
          if (resultFin[skill.key]) {
            arr.push(resultFin[skill.key]?.score)
          } else {
            arr.push(0)
          }
        } else {
          arr.push(0)
        }
      })


      let bgColor = ""
      let borderColor = ""
      let tooltipText = ""
      if (cat === labelsCategories[0]) {
        bgColor = "rgba(255, 81, 6, 0.2)"
        borderColor = "rgba(255, 81, 6, 1)"
        tooltipText = "Innovation et\ncommunication"
      } else if (cat === labelsCategories[1]) {
        bgColor = "rgba(79, 57, 255, 0.2)"
        borderColor = "rgba(79, 57, 255, 1)"
        tooltipText = "Éfficacité\nopérationnelle"
      } else if (cat === labelsCategories[2]) {
        bgColor = "rgba(243, 144, 255, 0.2)"
        borderColor = "rgba(243, 144, 255, 1)"
        tooltipText = "Collaboration et\nleadership"
      }


      datasets.push({
        title : index,
        data : arr,
        fill : true,
        backgroundColor: bgColor,
        borderColor: borderColor,
        borderDash : dashStyle,
        borderWidth : 1,
        pointRadius: 0,
        pointHoverRadius: 0,
        tooltipText: tooltipText,
        labelsNbr : labelsNbr,
      })
    })

    //on regarde pour lier les lignes
    let indexLabels = 0
    for (let d=0; d<datasets.length; d++) {
      //pour le premier dataset
      if (d === 0 && datasets?.length >= 2) { //pour le premier dataset
        let actDataset = datasets[d]
        let nextDataset = datasets[d+1]

        actDataset.data[actDataset?.labelsNbr] = nextDataset.data[actDataset?.labelsNbr]
      } else if (d === datasets?.length-1) { //pour le dernier dataset
        let actDataset = datasets[d]
        let firstDataset = datasets[0]
        actDataset.data[0] = firstDataset.data[0]
      } else {
        let actDataset = datasets[d]
        let nextDataset =  datasets[d+1]
        actDataset.data[indexLabels + datasets[d]?.labelsNbr] = nextDataset.data[indexLabels + datasets[d]?.labelsNbr]
      }

      indexLabels += datasets[d]?.labelsNbr
    }

    if (type === "recruiter") {
      let seuilsArr = []
      softSkillsByFamily?.forEach((skill) => {
        seuilsArr.push(skill?.seuil)
      })
      datasets.push({
        title : "SEUILS",
        data : seuilsArr,
        fill : true,
        backgroundColor: "rgba(254, 208, 48, 0.2)",
        borderColor: "rgba(254, 208, 48, 1)",
        borderDash : dashStyle,
        borderWidth : 1,
        pointRadius: 0,
        pointHoverRadius: 0,
      })
    }

    /*console.log({
      labels : labels,
      datasets : datasets,
      labelsDotColors : labelsDotColors,
      labelsIcons : type === "recruiter" ? labelsIcons : false,
      withoutTooltips : withoutTooltips,
    })*/


    return {
      labels : labels,
      datasets : datasets,
      labelsDotColors : labelsDotColors,
      labelsIcons : type === "recruiter" ? labelsIcons : false,
      withoutTooltips : withoutTooltips,
    }
  }

  const getCompletedOn = () => {
    if (type === "recruiter") {
      let findResult = actScan?.userResults?.find((el) => el.userID === user?.userID)
      let momentDate = moment(findResult?.resultUpdatedAt)
      return `${momentDate.format('DD/MM/YYYY')} à ${momentDate.format('HH:mm')}`
    } else if (type === "candidat") {
      let momentDate = moment(user?.resultUpdatedAt)
      return `${momentDate.format('DD/MM/YYYY')} à ${momentDate.format('HH:mm')}`
    }
  }

  const getUserName = () => {
    if (type === "recruiter") {
      return user?.userName
    } else if (type === "candidat") {
      return user?.name
    }
  }

  const { toPDF, targetRef } = usePDF({
    //method: 'open',
    filename : "Rapport "+user?.userName+" - "+actScan?.module?.name+".pdf",
    resolution: 2,
    page: {
      orientation: "portrait",
      margin:0,
      format : [1250/4, 1768.0000001/4]
    },
    overrides: {
     /*canvas: {
       ignoreElements: function (element) {
         if (element.id === "closeButton" || element.id === "downloadButton" || element.id === "closeButtonVisible" || element.id === "downloadButtonVisible") {
           return true
         } else {
           return false
         }
      }
    },*/
   },
  });


  return (
    <>
      {isOpen &&
        <>
          {type === "recruiter" &&
            <Rapport
              ref={targetRef}
              user={user}
              getDatasForChart={getDatasForChart}
              actScan={actScan}
            />
          }
          <MyModal
            isOpen={isOpen}
            maxWidth="md"
            onClose={onClose}
            overflow="hidden"
            background="white"
          >
            <Box sx={{display:"flex", width:"100%", height:"100%", alignItems:"center", flexDirection:"column", overflow:"hidden"}}>
              <Box sx={{
                display:"flex",
                flexDirection:"column",
                padding:"15px",
                width:"100%",
                overflow:"hidden",
                userSelect:"none",
              }}>
                <Box sx={{
                  textAlign:"right"
                }}>
                  <CloseIcon onClick={onClose} sx={{
                    cursor:"pointer",
                    color:"text.black",
                    width:["25px", "35px", "35px"],
                    height:["25px", "35px", "35px"],
                    marginBottom:["-10px", "-15px", "-15px"],
                  }}/>
                </Box>
                <Box sx={{
                  fontWeight:500,
                  color:"text.black",
                  fontSize:["28px", "36px", "42px"],
                  overflow:"hidden",
                  whiteSpace:"nowrap",
                  textOverflow:"ellipsis",
                  textAlign:"center"
                }}>
                  {getUserName()}
                </Box>
              </Box>
              <Box sx={{
                color:"text.primary",
                fontWeight:400,
                fontSize:["15px", "16px", "18px"],
                overflow:"hidden",
                whiteSpace:"nowrap",
                textOverflow:"ellipsis",
                maxWidth:"calc(100% - 20px)"
              }}>
                <span style={{textTransform:"none"}}>Terminé le </span>
                {getCompletedOn()}
              </Box>
              <Box sx={{flex:1, width:"100%", display:"flex", alignItems:"center"}}>
                <Box sx={{width:"100%", height:"100%"}}>
                  <Hidden smDown>
                    <NewCertifChart
                      datas={getDatasForChart()}
                    />
                  </Hidden>
                  <Hidden smUp>
                    <NewCertifChart
                      datas={getDatasForChart()}
                      forMobile
                    />
                  </Hidden>
                </Box>
              </Box>
              {type === "recruiter" &&
                <Box sx={{paddingBottom:"15px"}}>
                  <MyButton
                    toPDF={toPDF}
                  />
                </Box>
              }
            </Box>
          </MyModal>
        </>
      }
    </>
  )
};

const MyButton = ({toPDF}) => {
  const [isCreatingPDF, setIsCreatingPDF] = useState(false)
  return (
    <Button
      variant="contained"
      disabled={isCreatingPDF}
      size={"medium"}
      onClick={async () => {
        if (isCreatingPDF === false) {
          setIsCreatingPDF(true)
          await toPDF()
          setIsCreatingPDF(false)
        }
      }}
    >
      Télécharger le rapport
    </Button>
  )
}

export default ViewResultsModal;
